import { Autocomplete, Chip, SxProps, TextField, Theme } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

// ----------------------------------------------------------------------

interface RHFChipInputProps {
  name: string;
  label?: string;
  helperText?: React.ReactNode;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export default function RHFChipInput({
  name,
  label,
  helperText,
  placeholder,
  required = false,
  disabled = false,
  sx,
}: RHFChipInputProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          multiple
          freeSolo
          sx={[
            {
              '& .MuiChip-label': {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
              },
              '& .MuiChip-root': {
                height: 'auto',
                padding: '4px',
              },
            },
            ...(Array.isArray(sx) ? sx : [sx]),
          ]}
          value={field.value || []}
          onChange={(_, newValue) => {
            field.onChange(newValue);
          }}
          options={[]}
          disabled={disabled}
          renderTags={(value: string[], getTagProps) =>
            value.map((option: string, index: number) => (
              <Chip
                {...getTagProps({ index })}
                key={option}
                label={option}
                size="small"
                onDelete={() => {
                  const newValue = value.filter((_, i) => i !== index);
                  field.onChange(newValue);
                }}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              placeholder={placeholder}
              required={required}
              error={!!error}
              helperText={error ? error?.message : helperText}
            />
          )}
        />
      )}
    />
  );
}
